"use client";

import { Loader } from "@ui-kit";

export default function GameDetailsLoading() {
  return <Loader />;
}
